import { Route, NavigationGuardNext } from "vue-router";
import { ObjectiveModule } from "@/modules/objective";

export const ObjectiveManagerRouteResolver = async function (to: Route, from: Route, next: NavigationGuardNext) {
	await ObjectiveModule.getVCSLevelUnits();
	next();
};
